import {
    keyBy as _keyBy,
    groupBy as _groupBy,
    orderBy as _orderBy,
} from '@lodash';
import StoreUtil from '@store/StoreUtil';
import Article from '@core/models/news/Article';
import NewsService from '@core/services/news/NewsService';
// import ScheduledUtil from '@core/utils/scheduled/ScheduledUtil';
// import config from '@src/config';
// import Logger from '@loggers/Logger';
import slugifyDate from '@core/utils/url/slugifyDate';
import parseDate from '@core/utils/url/parseDateUrl';

const SET_ARTICLES = 'SET_ARTICLES';

export interface INewsState {
    articles: Article[];
}

export default {
    namespaced: true,

    state: {
        articles: [],
    } as INewsState,

    mutations: {
        [SET_ARTICLES]: StoreUtil.createSimpleMutator('articles'),
    },

    actions: {
        startScheduledNewsFetch: ({ dispatch }: { dispatch: any }) => {
            // dispatch('fetchNews');
            // ScheduledUtil.scheduleTask(
            //     () => {
            //         try {
            //             dispatch('fetchNews');
            //         } catch (error) {
            //             // we can ignore this exception because it will only
            //             // fail to fetch news once
            //             Logger.error(error);
            //         }
            //     },
            //     config.services.news.fetchNewsPeriod,
            // );
        },
        fetchNews: StoreUtil.asyncErrorGuard(async ({ commit }: { commit: any }) => {
            // commit(SET_ARTICLES, await NewsService.getInstance().getArticles());
            return;
        }),
    },
    getters: {
        availableDates: (store: INewsState, getters: any) => {
            const dates = Object.keys(getters.articlesByDate).map(parseDate);
            return _orderBy(dates, (date) => date.getTime(), ['desc']);
        },
        articlesByDate: (store: INewsState, getters: any) => {
            const orderedArticles = _orderBy(
                getters.articles,
                [
                    (article) => article.ordinal,
                    (article) => article.datePublished.getTime(),
                    (article) => article.shortTitle,
                ],
                ['asc', 'desc']);

            return _groupBy(orderedArticles, (article) => slugifyDate(article.datePublished));
        },
        articles: StoreUtil.createSimpleGetter('articles'),
        articlesById: (store: INewsState, getters: any) => _keyBy(getters.articles, 'id'),
        articlesByEventId: (store: INewsState, getters: any) =>
            _groupBy(
                _orderBy(getters.articles, (article) => article.datePublished.getTime(), ['desc']),
                'eventId',
            ),
        articlesForEvents(state: INewsState) {
            return function (eventIds: number[]) {
                return state.articles.filter((article: Article) => eventIds.includes(article.eventId));
            };
        }
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/news/newsIndex.ts